import React from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "../lib/api";
import { Seo } from "../lib/seo";
import { Section, SectionHead, Badge } from "../components/ui";
import { useReveal } from "../lib/useReveal";

export default function Changelog() {
  const { data } = useQuery({ queryKey: ["changelog"], queryFn: () => get("/changelog") });
  useReveal(data);
  return (
    <>
      <Seo title="Changelog" path="/changelog/" description="What shipped recently in BloomCONNECT — new features, improvements and fixes." />
      <Section>
        <SectionHead label="Changelog" title="What shipped recently." />
        <ol className="mt-10 space-y-8 border-l border-line pl-6">
          {(data || []).map((c) => (
            <li key={c.id} className="relative reveal-on-scroll">
              <span className="absolute -left-[27px] top-1.5 h-2 w-2 rounded-full bg-brand-600" />
              <div className="flex items-center gap-3"><span className="font-mono text-2xs text-ink-400">{c.date}</span><Badge>{c.tag}</Badge></div>
              <h3 className="mt-2 text-lg text-ink-950">{c.title}</h3>
              <p className="mt-1 text-ink-600 max-w-prose">{c.body}</p>
            </li>
          ))}
        </ol>
      </Section>
    </>
  );
}
